import { QueryKey, UseQueryResult, useQuery } from 'react-query';
import { GetSummaryReportsForSiteQueryParams } from '@pimm/services/lib/store-inspections/types';
import { GetSummaryReportsForSite } from '@pimm/services/lib/store-inspections/services';

export const useGetSummaryReportsBySite = (
  _query?: GetSummaryReportsForSiteQueryParams,
  _queryKey?: string,
): UseQueryResult<Awaited<ReturnType<typeof GetSummaryReportsForSite>>> => {
  const querySummaryReports = useQuery({
    enabled: !!_query?.siteId && !!_query.startDate && !!_query.endDate,
    queryKey: [_queryKey ?? 'GetSummaryReportsForSite', _query] as [QueryKey, GetSummaryReportsForSiteQueryParams],
    queryFn: ({ queryKey: [key, params] }) => GetSummaryReportsForSite(params, { 'api-version': '1.0', tenant: undefined } as any),
  });
  return querySummaryReports;
};
